import {Route, Routes} from 'react-router-dom';

import DoanhNghiep from './doanh-nghiep';
import CauHinhHoaDon from './cau-hinh-hoa-don';
import Emailing from './cau-hinh-email-server';
import Token from './chung-thu-so';
import ValueReplaces from './gia-tri-thay-the';
import ValueDefault from './gia-tri-mac-dinh';
import TenantSetting from './tham-so-he-thong';
import NguoiDung from './nguoi-dung';
import EmailMTT from './cau-hinh-email-TB-MTT';
import SynPetroLogToInvoice from './cau-hinh-dong-bo-hoa-don-xang-dau';

export default function System() {
  return (
    <Routes>
      <Route path="cau-hinh-hoa-don/*" element={<CauHinhHoaDon />} />
      <Route path="cau-hinh-email-server/*" element={<Emailing />} />
      <Route path="doanh-nghiep/*" element={<DoanhNghiep />} />
      <Route path="nguoi-dung/*" element={<NguoiDung />} />
      <Route path="chung-thu-so/*" element={<Token />} />
      <Route path="gia-tri-thay-the/*" element={<ValueReplaces />} />
      <Route path="gia-tri-mac-dinh/*" element={<ValueDefault />} />
      <Route path="tham-so-he-thong/*" element={<TenantSetting />} />
      <Route path="cau-hinh-email-tb-mtt" element={<EmailMTT />} />
      <Route path="cau-hinh-dong-bo-hoa-don-xang-dau/*" element={<SynPetroLogToInvoice />} />
    </Routes>
  );
}
